/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DefaultResponse
 */
export interface DefaultResponse {
    /**
     * 
     * @type {string}
     * @memberof DefaultResponse
     */
    _return: string;
}

export function DefaultResponseFromJSON(json: any): DefaultResponse {
    return DefaultResponseFromJSONTyped(json, false);
}

export function DefaultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '_return': json['return'],
    };
}

export function DefaultResponseToJSON(value?: DefaultResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'return': value._return,
    };
}


